import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { schedulingApi, AVAILABILITY_OVERVIEW_QUERY_KEY } from "api/scheduling";

interface UseAvailabilityOverviewArgs {
  propertyId?: number;
  unitId?: number;
  startDate: string;
  endDate: string;
}

export const useAvailabilityOverview = ({
  propertyId,
  unitId,
  startDate,
  endDate
}: UseAvailabilityOverviewArgs) =>
  useQuery({
    queryKey: [
      ...AVAILABILITY_OVERVIEW_QUERY_KEY,
      propertyId,
      unitId,
      startDate,
      endDate
    ],
    queryFn: () =>
      schedulingApi.getAvailabilityOverview({
        property_id: Number(propertyId),
        unit_id: Number(unitId),
        start_date: startDate,
        end_date: endDate
      }),
    enabled: Boolean(propertyId && unitId),
    // Keep the previous week's grid visible while the next week loads instead
    // of blanking to a spinner on every navigation.
    placeholderData: keepPreviousData
  });
